import { render, staticRenderFns } from "./add-partner-clinic.vue?vue&type=template&id=a040dfc0&"
import script from "./add-partner-clinic.vue?vue&type=script&lang=js&"
export * from "./add-partner-clinic.vue?vue&type=script&lang=js&"
import style0 from "./add-partner-clinic.vue?vue&type=style&index=0&id=a040dfc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports